import { InstallmentCalculator } from '../../ClientApp/services/installment-calculator';

describe('NewPortalWeb', () => {
	describe('services', () => {
		describe('installment-calculator', () => {
			let svc: InstallmentCalculator;
			const settings = { test: 'test' };
			const ballance = 6;

			beforeEach(() => {
				svc = new InstallmentCalculator(settings, ballance);
			});

			describe('Class initialization', () => {
				it('should initialize ballance', () => {
					expect(svc.balance).toEqual(ballance);
				});
				it('should initialize settings', () => {
					expect(svc.settings).toEqual(settings);
				});
			});

			describe('singlePaymentAmount', () => {
				const expected = ballance;
				it('should return proper ballance', () => {
					expect(svc.singlePaymentAmount()).toEqual(expected);
				});
			});
			describe('twoPaymentAmount', () => {
				const expected = ballance / 2;
				it('should return proper ballance', () => {
					expect(svc.twoPaymentAmount()).toEqual(expected);
				});
			});
			describe('threePaymentAmount', () => {
				const expected = ballance / 3;
				it('should return proper ballance', () => {
					expect(svc.threePaymentAmount()).toEqual(expected);
				});
			});
		});
	});
});
